/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';

export interface DeleteSurveyMarksSubmission$Params {
  submissionId: number;
}

export function deleteSurveyMarksSubmission(
  http: HttpClient,
  rootUrl: string,
  params: DeleteSurveyMarksSubmission$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    deleteSurveyMarksSubmission.PATH,
    'delete',
  );
  if (params) {
    rb.path('submissionId', params.submissionId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

deleteSurveyMarksSubmission.PATH = '/me/surveyMarks/submissions/{submissionId}';
